import { Card, CardContent } from "@/components/ui/card";

export default function ProviderSearchResultSkeleton() {
  return (
    <Card className="mx-auto w-full bg-white shadow-sm">
      <CardContent className="p-4">
        {/* Header Section Skeleton */}
        <div className="mb-4 flex items-start justify-between border-b border-gray-200 pb-4">
          <div className="flex-1 pr-4">
            {/* Provider name skeleton */}
            <div className="mb-1 h-6 w-3/4 animate-pulse rounded bg-gray-300" />
          </div>
          <div className="flex items-center gap-2">
            {/* Overall Rating text skeleton */}
            <div className="h-4 w-24 animate-pulse rounded bg-gray-300" />
            {/* Stars skeleton */}
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <div
                  key={star}
                  className="size-4 animate-pulse rounded bg-gray-300"
                />
              ))}
              {/* Dropdown arrow skeleton */}
              <div className="ml-1 size-4 animate-pulse rounded bg-gray-300" />
            </div>
          </div>
        </div>
        {/* Specialty and Network Tags Skeleton */}
        <div className="mb-4 flex items-center gap-3">
          {/* Specialty tag skeleton */}
          <div className="h-6 w-28 animate-pulse rounded-full bg-gray-300" />
          {/* Network tag skeleton */}
          <div className="h-6 w-48 animate-pulse rounded-full bg-gray-300" />
        </div>
        {/* Address and Distance Section Skeleton */}
        <div className="flex items-center justify-between">
          <div className="flex-1">
            {/* Address skeleton */}
            <div className="mb-2 h-4 w-5/6 animate-pulse rounded bg-gray-300" />
            {/* Distance skeleton */}
            <div className="h-4 w-32 animate-pulse rounded bg-gray-300" />
          </div>
          {/* Action Buttons Skeleton */}
          <div className="ml-4 flex items-center gap-2">
            <div className="size-8 animate-pulse rounded bg-gray-300" />
            <div className="size-8 animate-pulse rounded bg-gray-300" />
            <div className="size-8 animate-pulse rounded bg-gray-300" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
